"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.step.progress': 'Passo {current} di {total}',
};
